import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import BeneficiaryForm from 'containers/BeneficiaryForm'
import BeneficiaryComment from 'containers/BeneficiaryComment'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getBeneficiaries, getBeneficiaryLockedStatusAndRem, confirmBeneficiary } from 'actions/beneficiaries'
import { deleteBeneficiary } from 'actions/beneficiaryForm'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import BackToAdminCentre from 'components/BackToAdminCentre'
import { hasAccess } from 'utils/hasAccess'
import { headerTitleName } from 'utils/headerTitleName'
import { getEmployeeId } from 'utils/getEmployeeId'
import { commonFunctions } from 'utils/CommonFunctions'

class Beneficiaries extends Component {
  static propTypes = {
    beneficiaries: PropTypes.object.isRequired,
    confirmBeneficiary: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    deleteBeneficiary: PropTypes.func.isRequired,
    getBeneficiaries: PropTypes.func.isRequired,
    getBeneficiaryLockedStatusAndRem: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    routes: PropTypes.instanceOf(Array),
    selectedPartner: PropTypes.object,
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    selectedPartner: null,
    currentUser: null,
  }
  componentDidMount() {
    hasAccess(this.props.currentUser, 'Beneficiary', this.props.history)
    this.props.getBeneficiaries(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
    this.props.getBeneficiaryLockedStatusAndRem(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
  }

  handleConfirmBeneficiary = (body) => {
    this.props.confirmBeneficiary(body)
  }

  handleDeleteBeneficiary = (body) => {
    this.props.deleteBeneficiary(body)
  }

  handleGetBeneficiaries = () => {
    this.props.getBeneficiaries()
  }

  handleOpenBeneficiaryForm = () => {
    this.props.modalShow('beneficiaryForm')
  }

  handleOpenBeneficiaryCommentForm = () => {
    this.props.modalShow('beneficiaryComment')
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props

    return {
      name: headerTitleName(this.props.currentUser, 'Beneficiaries'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, currentUser, beneficiaries, selectedPartner,
    } = this.props
    return (
      <MainLayout
        bannerNavProps={{ ...this.bannerProps() }}
        partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
        sidebarType="partnerSideBar"
      >
        <BackToAdminCentre displayText={`${this.props.selectedPartner.Name}: Beneficiaries`} isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              beneficiaries={beneficiaries}
              confirmBeneficiary={this.handleConfirmBeneficiary}
              currentUser={currentUser}
              deleteBeneficiary={this.handleDeleteBeneficiary}
              getBeneficiaries={this.handleGetBeneficiaries}
              openBeneficiaryCommentForm={this.handleOpenBeneficiaryCommentForm}
              openBeneficiaryForm={this.handleOpenBeneficiaryForm}
              selectedPartner={selectedPartner}
              setErrorMessage={this.props.setErrorMessage}
            />
           ))}
        </Container>
        <BeneficiaryForm
          currentUser={currentUser}
          hide={this.props.modalHide}
        />
        <BeneficiaryComment
          currentUser={currentUser}
          hide={this.props.modalHide}
        />
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  beneficiaries: state.beneficiaries,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getBeneficiaries,
  getBeneficiaryLockedStatusAndRem,
  confirmBeneficiary,
  deleteBeneficiary,
  modalShow,
  modalHide,
})(Beneficiaries))



// WEBPACK FOOTER //
// ./src/containers/Beneficiaries.js